<div 
  class="show-animation d-flex flex-column p-3 card-body"
  (click)="onClick()"
>
  <div class="d-flex justify-content-between g-1">
    <div class="d-flex g-1 m-auto-0">
      <img class=".w-17" src="assets/chat/chat-icon.svg" [alt]="'COMPONENTS.CHAT_OPERADORES.NOTIFICACAO.CHAT_ICON_ALT' | transloco">
      <div class="d-flex flex-column g-03">
        <h6 class="m-0 main-header color-green">
            {{ 'COMPONENTS.CHAT_OPERADORES.NOTIFICACAO.NEW_MESSAGE' | transloco }}
        </h6>
        <h5 class="m-0 fw-bold remetente-header color-green">{{dadosNotificacao.mandadoPor}}</h5>
        <div>
          <p class="m-0 message-content">{{dadosNotificacao.mensagem}}</p>
          <span  class="message-hour">{{dadosNotificacao.hora}}</span>
        </div>
      </div>
    </div>
    <button (click)="OnCloseClick($event)" class="border-0 bg-transparent m-auto-0">
      <img class="drop-shadow w-15" src="assets/chat/close-icon.svg" [alt]="'COMPONENTS.CHAT_OPERADORES.NOTIFICACAO.CLOSE_ALT' | transloco">
    </button>
  </div>

  <mat-progress-bar 
    class="snackbar-chat"
    mode="determinate"
    [value]="progresso$ | async">
  </mat-progress-bar>
</div>